<template>
  <SysDialog v-model="menu_ativo" :largura="750">
    <template #ativador="{}">
      <SysBtn
        style="border: 1px solid #042333"
        :size="0"
        @click="menu_ativo = !menu_ativo"
      >
        <v-icon size="18" color="#042333">mdi-filter</v-icon>
        <span class="ml-1 text-systock-blue font-14">Filtros</span>
      </SysBtn>
    </template>

    <template #titulo.texto>
      <div>
        <p class="ma-0 font-18 text-gray-900">Filtragem de produtos</p>
        <p class="ma-0 font-12 font-weight-regular mt-n3 text-gray-200">Selecione o que deseja considerar no ajuste de pedido por meta</p>
      </div>
    </template>

    <div>
      <DivisorComLegenda legenda="Períodos" class="mb-5" />

      <div class="d-flex align-center">
        <div class="w-33-porcento pr-2">
          <v-autocomplete
            v-model="filtros.primeira_entrada"
            label="Primeira entrada"
            :items="selects.dias"
            item-text="descricao"
            item-value="valor"
            outlined
            multiple
            clearable
            hide-details
            small-chips
            :height="ALTURA_MINIMA_FILTROS_DIAS"
          />
        </div>

        <div class="w-33-porcento pr-2">
          <v-autocomplete
            v-model="filtros.ultima_entrada"
            label="Última entrada"
            :items="selects.dias"
            item-text="descricao"
            item-value="valor"
            outlined
            multiple
            clearable
            hide-details
            small-chips
            :height="ALTURA_MINIMA_FILTROS_DIAS"
          />
        </div>

        <div class="w-33-porcento">
          <v-autocomplete
            v-model="filtros.idade"
            label="Idade dos produtos"
            :items="selects.dias"
            item-text="descricao"
            item-value="valor"
            outlined
            multiple
            clearable
            hide-details
            small-chips
            :height="ALTURA_MINIMA_FILTROS_DIAS"
          />
        </div>
      </div>

      <DivisorComLegenda legenda="Curvas" class="my-5" />

      <div class="d-flex align-center">
        <div class="w-33-porcento pr-2">
          <SysCurvasAutocomplete
            v-model="filtros.curva_popularidade"
            outlined
            multiple
            hide-details
            clearable
            curva="popularidade"
          />
        </div>

        <div class="w-33-porcento pr-2">
          <SysCurvasAutocomplete
            v-model="filtros.curva_rentabilidade"
            outlined
            multiple
            hide-details
            clearable
            curva="rentabilidade"
          />
        </div>

        <div class="w-33-porcento">
          <SysCurvasAutocomplete
            v-model="filtros.curva_criticidade"
            outlined
            multiple
            hide-details
            clearable
            curva="criticidade"
          />
        </div>
      </div>

      <DivisorComLegenda legenda="Outros" class="my-5" />

      <div class="d-flex align-center">
        <div class="w-33-porcento pr-2">
          <SysCompradorAutocomplete
            v-model="filtros.compradores"
            label="Compradores"
            :qtde_visivel_selecionados="1"
            :ids-segmento="filtros.segmentos"
            outlined
            multiple
            hide-details
            clearable
          >
            <template #selection="{item}">
              <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="filtros.compradores" :item="item" item_value="nome_completo" />
            </template>
          </SysCompradorAutocomplete>
        </div>

        <div class="w-33-porcento pr-2">
          <SysLinhasAutocomplete
            v-model="filtros.linhas"
            label="Linhas"
            :qtde_visivel_selecionados="1"
            outlined
            multiple
            hide-details
            clearable
            @autoselecionado-linhas-com-movimento="aplicarFiltros"
          />
        </div>

        <div class="w-33-porcento">
          <SysSegmentoAutocomplete
            v-model="filtros.segmentos"
            label="Segmentos"
            :qtde-visivel-selecionados="1"
            outlined
            multiple
            hide-details
            clearable
          >
            <template #selection="{item}">
              <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="filtros.segmentos" :item="item" />
            </template>
          </SysSegmentoAutocomplete>
        </div>
      </div>

      <div class="d-flex align-center mt-3">
        <div class="w-33-porcento pr-2">
          <SysSecaoAutocomplete
            v-model="filtros.secoes"
            :qtde_visivel_selecionados="1"
            label="Seções"
            outlined
            multiple
            hide-details
            clearable
          />
        </div>

        <div class="w-33-porcento pr-2">
          <SysCategoriaAutocomplete
            v-model="filtros.categorias"
            :qtde_visivel_selecionados="1"
            label="Categorias"
            outlined
            multiple
            hide-details
            clearable
          />
        </div>

        <div class="w-33-porcento">
          <SysProdutosAutocomplete
            v-model="filtros.produtos"
            :qtde_visivel_selecionados="1"
            label="Produtos"
            outlined
            multiple
            hide-details
            clearable
            desabilitar_botao_selecao_todos
          />
        </div>
      </div>

      <div class="d-flex align-center mt-3">
        <div class="w-33-porcento pr-2">
          <SysStatusProduto v-model="filtros.status_produto" />
        </div>

        <div class="w-33-porcento pr-2">
          <SysHistograma v-model="filtros.histogramas" />
        </div>

        <div class="w-33-porcento">
          <SysAutocomplete
            v-model="filtros.pedidos_pendentes"
            label_props="Pedidos Pendentes"
            :items_props="selects.items_props_produtos_pendentes"
          />
        </div>
      </div>
    </div>

    <template #actions>
      <v-btn color="#042333" dark @click="aplicarFiltros">
        filtrar
      </v-btn>
    </template>
  </SysDialog>
</template>

<script>
import DivisorComLegenda from "@/components/utils/DivisorComLegenda.vue";
import SysCategoriaAutocomplete from "@/components/utils/crud/SysCategoriaAutocomplete.vue";
import SysLinhasAutocomplete from "@/components/utils/crud/SysLinhasAutocomplete.vue";
import SysStatusProduto from "@/components/utils/crud/SysStatusProduto.vue";
import SysSecaoAutocomplete from "@/components/utils/crud/SysSecaoAutocomplete.vue";
import TextoOutrosFiltrosSelecionadosAutocomplete from "@/components/Diagnostico/utils/TextoOutrosFiltrosSelecionadosAutocomplete.vue";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete.vue";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";
import SysAutocomplete from "@/components/utils/crud/SysAutocomplete.vue";
import SysHistograma from "@/components/Eventos/SazonalidadeFinal/Filtros/SysHistograma.vue";
import SysProdutosAutocomplete from "@/components/utils/crud/SysProdutosAutocomplete.vue";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import SysCurvasAutocomplete from "@/components/utils/crud/SysCurvasAutocomplete.vue";

export default {
  name: "Filtros",
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  components: {
    SysDialog,
    SysProdutosAutocomplete,
    SysHistograma,
    SysAutocomplete,
    SysCompradorAutocomplete,
    SysSegmentoAutocomplete,
    TextoOutrosFiltrosSelecionadosAutocomplete,
    SysSecaoAutocomplete,
    SysStatusProduto,
    SysLinhasAutocomplete,
    SysCategoriaAutocomplete,
    DivisorComLegenda,
    SysCurvasAutocomplete,
  },
  props: {
    modelValue: Object,
  },
  emits: ["update:modelValue"],
  data: () => ({
    menu_ativo: false,
    filtros: {
      primeira_entrada: [],
      ultima_entrada: [],
      idade: [],
      curva_popularidade: [],
      curva_rentabilidade: [],
      curva_criticidade: [],
      compradores: [],
      segmentos: [],
      secoes: [],
      categorias: [],
      status_produto: [],
      linhas: [],
      pedidos_pendentes: [],
      histogramas: [],
      produtos: [],
    },
    selects: {
      dias: [
        {valor: 1, descricao: '1. Menor que 90 dias'},
        {valor: 2, descricao: '2. Entre 90 e 180 dias'},
        {valor: 3, descricao: '3. Maior que 180 dias'},
      ],
      items_props_produtos_pendentes: [
        { id: 1, descricao: '1. Produtos sem Pedido Pendente' },
        { id: 2, descricao: '2. Produtos com Pedido Pendente' },
      ],
    }
  }),
  computed: {
    filtros_model_value_computed: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        return this.$emit("update:modelValue", valor);
      },
    },
    ALTURA_MINIMA_FILTROS_DIAS() {
      const {primeira_entrada, ultima_entrada, idade} = this.filtros;
      return Math.max(primeira_entrada.length, ultima_entrada.length, idade.length, 1) * 37;
    }
  },
  watch: {
    menu_ativo() {
      this.filtros = {...this.modelValue};
    }
  },
  methods: {
    aplicarFiltros() {
      this.menu_ativo = false;
      this.filtros_model_value_computed = {...this.filtros};
    }
  }
}
</script>

<style scoped>
</style>
